/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi,
    ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSON,
    ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSONTyped,
    ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20030
 */
export interface InlineResponse20030 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20030
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20030
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20030
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi>}
     * @memberof InlineResponse20030
     */
    results: Array<ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApi>;
}

export function InlineResponse20030FromJSON(json: any): InlineResponse20030 {
    return InlineResponse20030FromJSONTyped(json, false);
}

export function InlineResponse20030FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20030 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiFromJSON)),
    };
}

export function InlineResponse20030ToJSON(value?: InlineResponse20030 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjecForBackendApiActualvehicleStateApiToJSON)),
    };
}


